import { render } from "./UiPropSection.vue?vue&type=template&id=1e39f651"
import script from "./UiPropSection.vue?vue&type=script&lang=js"
export * from "./UiPropSection.vue?vue&type=script&lang=js"

import "./UiPropSection.vue?vue&type=style&index=0&id=1e39f651&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__